/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PracticeListItemDto
 */
export interface PracticeListItemDto {
    /**
     * Practice ID (UUID)
     * @type {string}
     * @memberof PracticeListItemDto
     */
    id: string;
    /**
     * Practice name
     * @type {string}
     * @memberof PracticeListItemDto
     */
    name: string;
    /**
     * Practice location (city)
     * @type {string}
     * @memberof PracticeListItemDto
     */
    location: string;
    /**
     * Available specialties at this practice
     * @type {Array<string>}
     * @memberof PracticeListItemDto
     */
    specialties: Array<string>;
}

/**
 * Check if a given object implements the PracticeListItemDto interface.
 */
export function instanceOfPracticeListItemDto(value: object): value is PracticeListItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('specialties' in value) || value['specialties'] === undefined) return false;
    return true;
}

export function PracticeListItemDtoFromJSON(json: any): PracticeListItemDto {
    return PracticeListItemDtoFromJSONTyped(json, false);
}

export function PracticeListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PracticeListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'location': json['location'],
        'specialties': json['specialties'],
    };
}

export function PracticeListItemDtoToJSON(json: any): PracticeListItemDto {
    return PracticeListItemDtoToJSONTyped(json, false);
}

export function PracticeListItemDtoToJSONTyped(value?: PracticeListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'location': value['location'],
        'specialties': value['specialties'],
    };
}

